<div class="nodata">
    <img src="/assets/images/backgrounds/work_in_progress.gif" alt="">
    <span [class.smallerText]="chotu" *ngIf="!button" #work [style]="'font-size:'+font+';'">{{part1}} <p #shift [style]="'font-size:'+font+';'">
            {{part2}}</p>
        {{part3}}</span>
    <button mat-raised-button [style]="'font-size:'+font+';'" *ngIf="button" class="addBtn" [class.clickIt]="clickIt"
        (click)="action()">{{part1}}
        {{part2}}
        {{part3}}</button>
</div>